import getSessionId from 'shared/utils/getSessionId';
import { api } from 'directual';
import { message } from 'antd';
import getUserId from 'shared/utils/getUserId';


export function getGroupList(isSupervisor) {
  const sessionId = getSessionId();
  return fetch(`/good/api/v5/data/group/getGroupList?pageSize=2000&sessionID=${sessionId}`,
    { method: 'GET' },
  )
    .then(response => response.json())
    .then(data =>
      data.payload.map(gr => ({
        ...gr,
        isLocked: gr.isLocked || (isSupervisor && gr.createdByUserId !== getUserId()),
      })),
    );
}

export function getUserListByGroup(groupId, page, searchString) {
  const lcSearchString = searchString.toLowerCase();
  const filters =
    [{
      field: 'groupArray',
      value: groupId,
      exp: 'in',
    }];
  if (searchString) {
    filters.push({
      field: 'searchString',
      value: lcSearchString,
      exp: 'like',
    });
  }
  const fields = 'id,fullName,email,positionName';
  const fetch = 'groupArray.{id+name},unitId.{name}';
  return api.structure('WebUser')
    .search({
      operator: 'AND',
      filters,
      fields,
      fetch,
      page,
      pageSize: 10,
      allObjects: true,
    })
    .then((data) => {
      const { result: { list, pageInfo } } = data;
      const payload = list
        .map(item => ({
          ...item.obj,
          groupArray: item.fetch.groupArray.groupArray,
          unitId: item.fetch.unitId.unitId,
        }));
      return Promise.resolve({ payload, total: pageInfo.tableSize });
    })
    .catch(() => {
      message.error('Ошибка поиска. Что-то пошло не так...', 1);
      return false;
    });
}

export function editGroup(data) {
  const sessionId = getSessionId();
  const request = data.id ? 'editGroup' : 'createGroup';
  const body = JSON.stringify(data);
  return fetch(`/good/api/v5/data/group/${request}?sessionID=${sessionId}`,
    { method: 'POST', json: true, body },
  )
    .then(response => response.json())
    .then(res => res.result[0]);
}

export function editGroupUserList(data) {
  const sessionId = getSessionId();
  const body = JSON.stringify(data);
  return fetch(`/good/api/v5/data/group/editGroupUserList?sessionID=${sessionId}`,
    { method: 'POST', json: true, body },
  )
    .then(response => response.json())
    .then(res => res.payload);
}



// WEBPACK FOOTER //
// ./src/Root/pages/Groups/http.js